export default __webpack_public_path__ + "media/images/flags/mn-77f7a1f69e97be62d7f53ad1f934c42b.png";